/// <amd-module name="TFS/Token/PatTokenPage/Components/NoTokenDisplay" />
import { PanelActionCreator, PanelOperationType } from 'Actions/PanelActionCreator';
import { Button } from "VSSUI/Button";
import { Icon } from 'VSSUI/Icon';
import { FontSizes, FontWeights, mergeStyleSets } from "OfficeFabric/Styling";
import { memoize } from "VSS/Core/Util/Memoize";
import * as React from 'react';
import * as Resources from "TFS/Token/PatTokenPage/Resources";

export interface INoTokenDisplayProps {
}

export interface INoTokenDisplayInternalProps {
    panelAction: PanelActionCreator;
}

export class NoTokenDisplayInternal extends React.PureComponent<INoTokenDisplayInternalProps, {}> {
    @memoize
    private static getStyles() {
        return mergeStyleSets({
            container: {
                display: "flex",
                alignItems: "center",
                flexDirection: "column"
            },
            keyIcon: {
                fontSize: 80,
                margin: "80px 0px 16px 0px"
            },
            noTokenText: {
                fontWeight: FontWeights.semilight,
                fontSize: FontSizes.xxLarge,
                textAlign: "center",
                maxWidth: 400,
                padding: 20
            }
        })
    }

    render() {
        const styles = NoTokenDisplayInternal.getStyles();

        return (
            <div className={styles.container}>
                <Icon
                    iconName={'Permissions'}
                    className={styles.keyIcon}
                />
                <div className={styles.noTokenText}>{Resources.PatListNoTokenText}</div>
                <Button
                    primary={true}
                    text={Resources.NewToken}
                    iconProps={{ iconName: 'Add' }}
                    onClick={this.openAddDialog}
                />
            </div>
        )
    }

    private openAddDialog = () => {
        this.props.panelAction.openTokenPanel(PanelOperationType.Add);
    }
}

export const NoTokenDisplay = (props: INoTokenDisplayProps) =>
    <NoTokenDisplayInternal
        {...props}
        panelAction={PanelActionCreator.getInstance()}
    />;

